























import Vue from 'vue';
import { mapActions, mapGetters } from 'vuex';

import { BButton } from 'bootstrap-vue';

import { ObjectType } from '../types';

export default Vue.extend({
  name: 'ToDoListZeroState',
  components: {
    BButton,
  },
  props: {
    // In ModelMetaSchema.humanSingular form
    objectType: {
      type: String,
      // Passing no object type means there are zero objects in the To-Do List category.
      default: null,
    },
  },
  computed: {
    ...mapGetters(['modelMeta']),
    categoryHasZeroObjects(): boolean {
      return !this.objectType;
    },
    objectTypeHasCreateNewButton() {
      return this.objectType != ObjectType.Assessment;
    },
    objectTypes() {
      if (this.categoryHasZeroObjects) return [ObjectType.Task, ObjectType.Request];

      return this.objectTypeHasCreateNewButton ? [this.objectType] : [];
    },
    message() {
      const objectText = this.categoryHasZeroObjects ? 'objects' : this.modelMeta[this.objectType].titlePlural;

      return this.objectTypeHasCreateNewButton
        ? `You have no ${objectText} in your To-Do List.\nWould you like to create one?`
        : `You have no ${objectText} in your To-Do List.`;
    },
  },
  methods: {
    ...mapActions('todoList', ['openNewObjectModal']),
  },
});
